import { render, staticRenderFns } from "./dashboard-master-loader.vue?vue&type=template&id=06233e43&scoped=true&"
import script from "./dashboard-master-loader.vue?vue&type=script&lang=js&"
export * from "./dashboard-master-loader.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-master-loader.vue?vue&type=style&index=0&id=06233e43&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06233e43",
  null
  
)

export default component.exports